import { PRODUCT_LOANS } from '@/constants/products';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/banking/loans';

export default async ({ $api, $apolloQuery, store }) => {
  await $api('banking/loansearches').then(r => store.commit('products/setValidations', r));
  await $apolloQuery(getProviders, { product: PRODUCT_LOANS }).then(lenders => store.commit('providers/setList', lenders));
  store.$i18n.mergeLocaleMessage('en', lang.en);
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('lenders.description');
  const subtitle = store.$i18n.t('lenders.subtitle');
  const title = store.$i18n.t('lenders.title');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
